import { render, staticRenderFns } from "./score-cow.vue?vue&type=template&id=e6c6818a&"
import script from "./score-cow.vue?vue&type=script&lang=js&"
export * from "./score-cow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports